export default __webpack_public_path__ + "static/media/mobileBusinessLaunchImage.368e2ab9.jpg";